
































import Vue from 'vue'
import { createEntitlement, fetchEntitlementTypesList } from '../services/inventory-client'
import { EntitlementCreateData, EntitlementTypeData } from '../types'
import EntitlementsForm from '../components/EntitlementsForm.vue'

export default Vue.extend({
  name: 'EntitlementsCreate',
  components: {
    EntitlementsForm
  },
  data () {
    return {
      isLoading: false,
      showForm: false,
      clearForm: false,
      entitlementTypesList: []
    }
  },
  mounted () {
    this.$store.commit('global/setLoading', true)
    this.isLoading = true
    fetchEntitlementTypesList(``)
      .then((items: Array<EntitlementTypeData>) => {
        items.forEach((item: EntitlementTypeData, index: number) => {
          Vue.set(this.entitlementTypesList, index, item)
        })
      })
      .catch(error => {
        this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
      })
      .finally(() => {
        this.showForm = true
        this.isLoading = false
        this.$store.commit('global/setLoading', false)
      })
  },
  methods: {
    onSubmit (entitlement: EntitlementCreateData) {
      this.isLoading = true
      createEntitlement(entitlement)
        .then(() => {
          this.clearForm = true
          this.$store.commit('global/addNotification', {
            text: 'You successfully created new entitlement!',
            type: 'success'
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    onClearForm () {
      this.clearForm = false
    }
  }
})
